var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.OnboardingStatus !== null)?_c('div',[(_vm.OnboardingStatus === 0)?_c('PatientNoMatching'):_vm._e(),_c('PatientOnboarding',{attrs:{"OnboardingStatus":_vm.OnboardingStatus},on:{"OnBookingCreatedFromCalendar":_vm.GetOnboardingStatus}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }